import { DoubleRightOutlined } from "@ant-design/icons";
import { Button, Col, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import DrillDownViewTable from "../DrillDownViewTable";
import PatientProfile from "../PatientProfile/PatientProfile";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";


import "./drillDownView.scss";
import dashboardService from "@services/dashboard.service";
// import { forEach } from "lodash";
import DrillDownViewForMonth from "../DrillDownViewForMonth/drillDownViewForMonth";

const DrillDownView = (props:any) => {

    const [activeTabKey, setActiveTabKey] = useState("1");
    const collapsedProfile = useCalenderViewStore((state) => state.collapsedProfile);
    const setCollapsedProfile = useCalenderViewStore((state) => state.setCollapsedProfile);
    const setIsDrillDownViewSelected = useCalenderViewStore((state) => state.setIsDrillDownViewSelected);
    const isDrillDownViewSelected = useCalenderViewStore((state) => state.isDrillDownViewSelected);
    const selectedPatientProfile = useCalenderViewStore((state) => state.selectedPatientProfile);
    // const [patientName, setPatientName] = useState("");
    // const [patientIdObj, setPatientIdObj] = useState<any>({});
    const [patientDetailsList, setPatientDetailsList] = useState<any>([]);
    const [isloadingpatientInfo, setIsloadingpatientInfo] = useState(false);
    const [patientDayAppointmentDetails, setpatientDayAppointmentDetails] = useState<any>([]);
    const [appointmentInfoLoading, setAppointmentInfoLoading] = useState<boolean>(false);
    const isProfileView = useCalenderViewStore((state) => state.isProfileView);
    const setViewForCalender = useCalenderViewStore((state) => state.setViewForCalender);

    useEffect(()=>{
        console.log("DrillDownView.useEffect");
        const getPatientAppointmentDetailsByPatientID = () => {
            console.log("DrillDownView.getPatientAppointmentDetailsByPatientID");
            setAppointmentInfoLoading(true)
            dashboardService.fetchCalenderViewPatientDayAppointmentDetailsByPatientID(selectedPatientProfile).subscribe({
                next: (v) => {
                    setpatientDayAppointmentDetails(v.data.data.result)
                    setAppointmentInfoLoading(false)
                },
    
                error: (e) => {
                  console.log(e);
                  setAppointmentInfoLoading(false)
                },
              }
            )
        }
        const getPatientProfile = () => {
            console.log("DrillDownView.useEffect");
            dashboardService.fetchCalenderViewPatientProfileByPatientID(selectedPatientProfile).subscribe({
                next: (v) => {
                    let res = v.data.data.result[0];
                    // let ptName="";
                    // let ptID={};
                    // let ptbody:any=[];
    
                    // // forEach(res, (ob)=>{
                    // //     if(ob.columnName==="patient_name")ptName=ob.value;
                    // //     else if(ob.columnName ==="patient_id")ptID={...ob};
                    // //     else ptbody.push(ob);
                    // // })
                    // // setPatientName(ptName);
                    // // setPatientIdObj({...ptID});
                    setPatientDetailsList(res)
                    setIsloadingpatientInfo(true);
                },
    
                error: (e) => {
                  console.log(e);
                },
              });
        }
        if(isProfileView){
            getPatientProfile();
            getPatientAppointmentDetailsByPatientID();
        }
    },[isProfileView, selectedPatientProfile]);



    const back = () => {
        isProfileView?setViewForCalender(true):setViewForCalender(false);
        setIsDrillDownViewSelected(!isDrillDownViewSelected);
    }

    const callback = (key:any) => {
        setActiveTabKey(key)
    }



    return(
        <div className="drillDownView-root">
            <div className="drillDownView-root__title-container">
                <Button
                    type="text"
                    shape="circle"
                    size={"large"}
                    className="drillDownView-root__title-container__back-btn"
                    onClick={() => back()}
                    >
                    <i className="drillDownView-root__title-container__back-btn__icon icon-arrow-left"></i>
                </Button>
                <div className="drillDownView-root__title-container__title-name">{isProfileView?"Patient Information":"Appointment Details"}</div>
            </div>
            <div className="drillDownView-root__container-table profile-transition">
                <Row gutter={16}className="drillDownView-root__container-table__row-body profile-transition">
                    {props.isProfileView && !collapsedProfile && (
                    <Col span={6}>
                        <PatientProfile
                        setCollapsedProfile={setCollapsedProfile}
                        collapsedProfile={collapsedProfile}
                        patientDetailsList={patientDetailsList}
                        // patientName={patientName}
                        // patientIdObj={patientIdObj}
                        isloadingpatientInfo={isloadingpatientInfo}
                        className="drillDownView-root__container-table__row-body__profile-body-width profile-transition"
                        />
                    </Col>
                    )}
                    <Col span={props.isProfileView ?  collapsedProfile ? 24 : 18 : 24} className="drillDownView-root__container-table__row-body__table">
                        <div className="drillDownView-root__container-table__row-body__table__container-div">
                            {props.isProfileView && collapsedProfile && (
                                <div onClick={() => setCollapsedProfile(!collapsedProfile)}>
                                    <Tooltip
                                        overlayInnerStyle={{
                                        padding: "12px",
                                        borderRadius: "8px",
                                        backgroundColor: "#091e42",
                                        height: "40px",
                                        lineHeight: 1,
                                        }}
                                        title="Show Patient Profile"
                                    >
                                        <Button
                                            className="drillDownView-root__container-table__row-body__table__container-div__profile-expand-btn"
                                            icon={<DoubleRightOutlined />}
                                            size={"middle"}
                                            onClick={() => setCollapsedProfile(!collapsedProfile)}
                                        />
                                    </Tooltip>
                                </div>
                            )}
                            {isProfileView? (<div className="member-data">
                                <DrillDownViewTable appointmentInfoLoading ={appointmentInfoLoading} activeTabKey={activeTabKey} callback={callback} patientDayAppointmentDetails={patientDayAppointmentDetails}/>
                            </div>):<div className="member-data"><DrillDownViewForMonth activeTabKey={activeTabKey} callback={callback}/></div>}
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}


export default DrillDownView;